var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShotSyringe = function SvgShotSyringe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M28.335 4.918c12.565 0 22.75 10.185 22.75 22.75s-10.185 22.75-22.75 22.75-22.75-10.185-22.75-22.75 10.185-22.75 22.75-22.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m48.271 38.99-.735-.98a4.9 4.9 0 0 1-.98-2.957v-1.225h-6.16v1.224c0 1.068-.35 2.1-.98 2.958l-.735.98a3.72 3.72 0 0 0-.735 2.222c0 .683.543 1.225 1.225 1.225h8.61c.683 0 1.225-.542 1.225-1.224a3.76 3.76 0 0 0-.735-2.223"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "m48.271 38.99-.735-.98a4.9 4.9 0 0 1-.98-2.957v-1.225h-3.08v8.61h4.305c.683 0 1.225-.543 1.225-1.226a3.76 3.76 0 0 0-.735-2.222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M37.926 46.132a2.883 2.883 0 0 0 2.87 2.87h5.337a2.883 2.883 0 0 0 2.87-2.87v-4.918H37.927z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M46.534 35.054h-6.16a1.217 1.217 0 0 1-1.225-1.225c0-.682.543-1.225 1.225-1.225h6.16c.683 0 1.225.543 1.225 1.225 0 .683-.542 1.225-1.225 1.225"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M43.477 41.214v7.788h2.66a2.883 2.883 0 0 0 2.87-2.87v-4.918z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M47.782 33.83c0-.683-.542-1.226-1.225-1.226h-3.08v2.468h3.08c.682 0 1.225-.543 1.225-1.225z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M7.368 48.634a1.236 1.236 0 0 1 0-1.732l6.474-6.475a1.236 1.236 0 0 1 1.733 0c.473.472.473 1.26 0 1.732L9.1 48.634a1.236 1.236 0 0 1-1.732 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "m9.098 48.633 6.475-6.476a1.236 1.236 0 0 0 0-1.732L7.348 48.65c.473.473 1.26.473 1.733 0z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35 14.037 5.215-5.215 6.965 6.965-5.215 5.215z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "m38.486 17.52 5.215-5.215 3.483 3.483-5.215 5.215z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.846 42.157a3.073 3.073 0 0 1 0-4.358l3.045-3.045 4.358 4.358-3.046 3.045a3.074 3.074 0 0 1-4.357 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "m18.183 42.157 3.044-3.045-2.17-2.17-5.214 5.215a3.074 3.074 0 0 0 4.357 0z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M22.54 43.91 12.093 33.461a1.236 1.236 0 0 1 0-1.733L28.91 14.912a1.236 1.236 0 0 1 1.732 0L41.09 25.359c.472.473.472 1.26 0 1.733L24.272 43.909a1.236 1.236 0 0 1-1.732 0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#007C83",
    d: "M22.54 43.908c.473.472 1.26.472 1.733 0L41.091 27.09a1.236 1.236 0 0 0 0-1.732l-5.215-5.216L17.308 38.71l5.215 5.215z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "M33.849 25.64a1.236 1.236 0 0 0-1.733 0l-.297.297-1.733-1.733.298-.297a1.236 1.236 0 0 0 0-1.733 1.236 1.236 0 0 0-1.733 0l-2.905 2.905a3.6 3.6 0 0 0-1.067 2.415 3.76 3.76 0 0 0-2.415 1.068l-2.905 2.905a1.236 1.236 0 0 0 0 1.732c.472.473 1.26.473 1.732 0l.297-.297 1.733 1.732-.297.298a1.236 1.236 0 0 0 0 1.732c.472.473 1.26.473 1.732 0l2.905-2.905a3.6 3.6 0 0 0 1.068-2.415 3.76 3.76 0 0 0 2.415-1.067l2.905-2.905a1.236 1.236 0 0 0 0-1.733m-3.763 2.03-.875.874a1.236 1.236 0 0 1-1.732 0 1.236 1.236 0 0 1 0-1.732l.875-.875zm-6.965 3.482.875-.875a1.236 1.236 0 0 1 1.733 0c.472.472.472 1.26 0 1.732l-.875.875z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m28.91 14.913 3.482-3.483 12.18 12.18-3.482 3.483z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "m35 21 3.483-3.483 6.09 6.09-3.483 3.483z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M43.997 24.763 31.239 12.005a1.236 1.236 0 0 1 0-1.732 1.236 1.236 0 0 1 1.733 0L45.729 23.03c.473.473.473 1.26 0 1.732a1.236 1.236 0 0 1-1.732 0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M43.999 24.763c.472.472 1.26.472 1.732 0a1.236 1.236 0 0 0 0-1.733l-6.388-6.388-1.732 1.733z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F6",
    d: "M46.9 17.22 38.78 9.1a1.236 1.236 0 0 1 0-1.732 1.236 1.236 0 0 1 1.733 0l8.12 8.12c.472.472.472 1.26 0 1.732a1.236 1.236 0 0 1-1.733 0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D5DB",
    d: "M46.9 17.223c.473.472 1.26.472 1.733 0a1.236 1.236 0 0 0 0-1.733l-4.06-4.06-1.733 1.733z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#003E52",
    d: "m30.08 27.668-.875.875a1.236 1.236 0 0 1-1.733 0l-1.732 1.733c.472.472.472 1.26 0 1.732l-.875.875-.875-.875-1.733 1.733.875.875-.297.297a1.236 1.236 0 0 0 0 1.733c.472.472 1.26.472 1.732 0l2.905-2.905a3.6 3.6 0 0 0 1.068-2.415 3.76 3.76 0 0 0 2.415-1.068l2.905-2.905a1.236 1.236 0 0 0 0-1.732 1.236 1.236 0 0 0-1.733 0l-.297.297-.875-.875-1.733 1.733.875.875z"
  })));
};
export default SvgShotSyringe;